(() => {
  'use strict';

  function getHomeMain() {
    return document.querySelector('#MainContent');
  }

  function getMainSections(main) {
    return Array.from(main.children).filter((element) =>
      element.classList.contains('shopify-section')
    );
  }

  function createStackGroup(sections, groupClass) {
    if (!sections || sections.length < 2) return;

    const parent = sections[0].parentNode;

    const validSections = sections.filter(
      (section) => section && section.parentNode === parent
    );

    if (validSections.length < 2) return;

    const wrapper = document.createElement('div');

    wrapper.classList.add(
      'calvo-stack-group',
      groupClass
    );

    parent.insertBefore(wrapper, validSections[0]);

    validSections.forEach((section, index) => {
      section.classList.add('calvo-stack-section');

      section.style.setProperty(
        '--calvo-stack-index',
        index + 1
      );

      wrapper.appendChild(section);
    });

    /* La última sección cierra el efecto */
    validSections[
      validSections.length - 1
    ].classList.add('calvo-stack-last');
  }


  /* ==========================================
     GRUPO 1
     SLIDESHOW → TAB COLLECTIONS
  ========================================== */

  function createHeroStack(main) {
    const sections = getMainSections(main);

    if (sections.length < 2) return;

    const slideshow = sections[0];
    const tabCollections = sections[1];

    createStackGroup(
      [slideshow, tabCollections],
      'calvo-stack-group--hero'
    );
  }


  /* ==========================================
     GRUPO 2
     TODOS LOS SHOP THE LOOK
     Se detectan automáticamente
  ========================================== */

  function createShopTheLookStack(main) {

    const shopTheLookSections = Array.from(
      main.querySelectorAll(
        ':scope > .shopify-section[id*="__section_look_"]'
      )
    );

    if (shopTheLookSections.length < 2) return;

    createStackGroup(
      shopTheLookSections,
      'calvo-stack-group--shop-look'
    );
  }

  /* ==========================================
   GRUPO 3
   COLLECTION PAGE
   IMAGE BANNER → RICH TEXT
========================================== */

/* ==========================================
   GRUPO 3
   COLLECTION PAGE
   IMAGE BANNER → RICH TEXT
========================================== */

/* ==========================================
   GRUPO 3
   COLLECTION PAGE
   IMAGE BANNER → RICH TEXT
========================================== */

function createCollectionBannerStack(main) {

  /*
    Broadcast utiliza .image__hero dentro
    de la sección Image Banner.
  */
  const bannerInner = main.querySelector(
    '.image__hero, .image__hero__pane, .image__hero__scale'
  );

  if (!bannerInner) {
    console.log('CALVO STACK: banner Broadcast no encontrado');
    return;
  }

  /*
    Subimos hasta el wrapper real de Shopify.
  */
  const imageBanner = bannerInner.closest('.shopify-section');

  if (!imageBanner) {
    console.log('CALVO STACK: wrapper Image Banner no encontrado');
    return;
  }


  /*
    Buscamos la siguiente sección Shopify.
    En tus plantillas es siempre Rich Text.
  */
  let richText = imageBanner.nextElementSibling;

  while (
    richText &&
    !richText.classList.contains('shopify-section')
  ) {
    richText = richText.nextElementSibling;
  }


  if (!richText) {
    console.log('CALVO STACK: Rich Text no encontrado');
    return;
  }

/*
  Buscamos también la siguiente sección:
  RKN - Subcolecciones
*/
let subcollections = richText.nextElementSibling;

while (
  subcollections &&
  !subcollections.classList.contains('shopify-section')
) {
  subcollections = subcollections.nextElementSibling;
}

if (!subcollections) {
  console.log('CALVO STACK: Subcolecciones no encontradas');
  return;
}

  console.log(
  'CALVO STACK COLLECTION:',
  imageBanner.id,
  '→',
  richText.id,
  '→',
  subcollections.id
);


  createStackGroup(
  [imageBanner, richText, subcollections],
  'calvo-stack-group--collection-banner'
);

}

  /* ==========================================
     INICIO
  ========================================== */

  function initCalvoStacks() {

    const main = getHomeMain();

if (!main) return;


/* ==========================================
   HOME
========================================== */

if (document.body.classList.contains('template-index')) {

  /* Primero nuestros 3 Shop the Look */
  createShopTheLookStack(main);

  /* Después Slideshow + Tab Collections */
  createHeroStack(main);

}


/* ==========================================
   COLLECTIONS
========================================== */

if (
  document.body.classList.contains('template-collection') ||
  window.location.pathname.startsWith('/collections/')
) {

  createCollectionBannerStack(main);

}
}

  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initCalvoStacks
    );

  } else {

    initCalvoStacks();

  }

})();
/* =========================================================
   SHOP THE LOOK POPUP — Z-INDEX FIX
========================================================= */

(() => {

  function popupIsVisible(popup) {

    if (!popup) return false;

    const style = window.getComputedStyle(popup);
    const rect = popup.getBoundingClientRect();

    if (
      style.display === 'none' ||
      style.visibility === 'hidden' ||
      parseFloat(style.opacity) === 0
    ) {
      return false;
    }

    /*
      Comprobamos si el popup está realmente dentro
      de la pantalla.
    */
    return (
      rect.right > 0 &&
      rect.left < window.innerWidth &&
      rect.bottom > 0 &&
      rect.top < window.innerHeight
    );
  }


  function updateLookPopupLayer() {

    const sections = document.querySelectorAll(
      '.calvo-stack-group--shop-look > .calvo-stack-section'
    );

    sections.forEach((section) => {

      const popup = section.querySelector(
        '[data-popup-container]'
      );

      if (popupIsVisible(popup)) {

        section.classList.add(
          'calvo-popup-active'
        );

      } else {

        section.classList.remove(
          'calvo-popup-active'
        );

      }

    });

  }


  /*
    El tema modifica clases/atributos cuando
    abre y cierra el panel de productos.
  */

  const popupObserver = new MutationObserver(() => {

    window.requestAnimationFrame(
      updateLookPopupLayer
    );

  });


  function initLookPopupFix() {

    const lookGroup = document.querySelector(
      '.calvo-stack-group--shop-look'
    );

    if (!lookGroup) return;

    popupObserver.observe(
      lookGroup,
      {
        subtree: true,
        attributes: true,
        attributeFilter: [
          'class',
          'style',
          'aria-hidden',
          'open'
        ]
      }
    );


    /*
      También comprobamos después de cada click
      porque algunas animaciones se ejecutan
      unos milisegundos después.
    */

    document.addEventListener(
      'click',
      () => {

        requestAnimationFrame(
          updateLookPopupLayer
        );

        setTimeout(
          updateLookPopupLayer,
          350
        );

      }
    );


    updateLookPopupLayer();

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initLookPopupFix
    );

  } else {

    initLookPopupFix();

  }

})();